module.exports = __webpack_public_path__ + "static/media/Elizabeth Yount.97e575c3.png";